import api from './api';

export const registrationService = {
  create: async (eventId, data) => {
    const response = await api.post(`/registrations/${eventId}`, data);
    return response.data;
  },

  getByEventId: async (eventId) => {
    const response = await api.get(`/registrations/${eventId}`);
    return response.data;
  },

  delete: async (eventId, id) => {
    const response = await api.delete(`/registrations/${eventId}/${id}`);
    return response.data;
  },

  exportCSV: async (eventId) => {
    const response = await api.get(`/registrations/${eventId}/export/csv`, {
      responseType: 'blob'
    });
    return response.data;
  },

  drawWinner: async (eventId) => {
    const response = await api.get(`/registrations/${eventId}/draw/winner`);
    return response.data;
  },

  importXLSX: async (eventId, file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/registrations/${eventId}/import/xlsx`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    return response.data;
  },

  toggleAcceptMessages: async (eventId, id) => {
    const response = await api.put(`/registrations/acceptmessage/${eventId}/${id}`);
    return response.data;
  }
};
